import { useRegisterSW } from "virtual:pwa-register/react";

// usePwaUpdate registra el service worker (F4 #55) y expone el estado de actualización.
// Montarlo (en RootLayout, siempre presente) es lo que dispara el registro del SW —el
// plugin va con injectRegister:false—, de modo que la app es instalable desde cualquier
// ruta, incluida /login. Con registerType 'prompt' el SW nuevo queda en espera y NO
// recarga solo: `needRefresh` se pone a true y la recarga la decide el técnico (evita
// perder una operación LOTO a medias). `update()` activa el SW en espera y recarga;
// `dismiss()` oculta el aviso hasta el próximo arranque.
export type PwaUpdate = {
  needRefresh: boolean;
  update: () => void;
  dismiss: () => void;
};

export function usePwaUpdate(): PwaUpdate {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  return {
    needRefresh,
    update: () => {
      // reloadPage=true: skipWaiting + recarga cuando el SW nuevo toma el control.
      void updateServiceWorker(true);
    },
    dismiss: () => setNeedRefresh(false),
  };
}
